import React from 'react';
import {RsnButton, RsnDialog} from '~/library/ui-kit';

export function TotalReceiveDialog() {
    return (
        <RsnDialog.Window placement='center'>
            <RsnDialog.CenteredHeader text='Total receive' />
            <RsnDialog.Body>
                Your bank may charge fees during the transfer. These fees are not included in this amount and may reduce
                the final credited amount.
            </RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike as={RsnDialog.CloseTrigger} intent={'secondary'}>
                    I got it
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
